/**
 * Mirrors api/forms/create_agency.py + api/models/enum_fields.py (AgencyTypes,
 * CompanySize, CandidateNotificationMethod) for admin API payloads.
 */

export const AGENCY_TYPE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'Agency & Clients', label: 'Agency and Clients' },
  { value: 'Holding & Subsidiaries', label: 'Holding and Subsidiaries' },
  { value: 'Main Operator & Companies', label: 'Main Operator and Companies' },
  { value: 'Team & Depratments', label: 'Team and Depratments' },
]

export const COMPANY_SIZE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '1:10', label: 'Micro Enterprise (1:10)' },
  { value: '10:50', label: 'Small (10:50)' },
  { value: '50:250', label: 'Medium (50:250)' },
  { value: '250 or more', label: 'Large Enterprise (250 or more)' },
]

export const JOB_SEEKER_REGISTRATION_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
]

export const UNIT_NAMING_TYPE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'branch_department', label: 'Branch / Department' },
  { value: 'central_local', label: 'Central Unit / Local Unit' },
  { value: 'project_squad', label: 'Project / Squad' },
  { value: 'department_unit', label: 'Department / Unit' },
]
